import { Action, combineReducers } from '@ngrx/store';

import {
  CORE_SHOP_THE_LOOK_FEATURE_KEY,
  EDIT_SHOP_THE_LOOK_FEATURE_KEY,
  SHOP_THE_LOOKS_FEATURE_KEY,
} from './constants';
import {
  coreShopTheLookReducer,
  CoreShopTheLookState,
} from './core/shop-the-look-core.reducer';
import {
  editShopTheLookReducer,
  EditShopTheLooksState,
} from './edit/edit-shop-the-look-reducer';
import {
  shopTheLooksReducer,
  ShopTheLooksState,
} from './shop-the-looks/shop-the-looks-reducer';

export interface State {
  [SHOP_THE_LOOKS_FEATURE_KEY]: ShopTheLooksState;
  [EDIT_SHOP_THE_LOOK_FEATURE_KEY]: EditShopTheLooksState;
  [CORE_SHOP_THE_LOOK_FEATURE_KEY]: CoreShopTheLookState;
}

export function reducers(state: State | undefined, action: Action) {
  return combineReducers({
    [SHOP_THE_LOOKS_FEATURE_KEY]: shopTheLooksReducer,
    [EDIT_SHOP_THE_LOOK_FEATURE_KEY]: editShopTheLookReducer,
    [CORE_SHOP_THE_LOOK_FEATURE_KEY]: coreShopTheLookReducer,
  })(state, action);
}
